const INITIAL_STATE = {
    feed: [],
    count: 0,
    loading: false
  }
  
  export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case "GET_FEEDS": {
        return {
          ...state,
          feed: action.data,
          count: action.count,
          loading: false
        }
      }
      default:
        return state
    }
  }
  